import React from 'react';
import { CTAButton } from './CTAButton';
export function Offer() {
  return <section id="precio" className="py-20 md:py-32 relative overflow-hidden" data-id="element-113">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-114"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-115">
        <div className="max-w-3xl mx-auto glass-panel p-8 md:p-16 text-center border-amber-500/20 shadow-[0_0_50px_rgba(0,0,0,0.5)]" data-id="element-116">
          <h2 className="text-3xl md:text-5xl mb-6" data-id="element-117">
            Recupera hoy mismo la seguridad de una mente nítida.
          </h2>

          <p className="text-lg text-steel-300 mb-10" data-id="element-118">
            El acceso completo a "Memoria de Acero: El Protocolo de Noche" está
            disponible por una inversión única.
          </p>

          <div className="mb-10" data-id="element-119">
            <span className="text-steel-400 text-lg uppercase tracking-wider font-semibold" data-id="element-120">
              Precio Especial
            </span>
            <div className="mt-4 flex items-center justify-center gap-3" data-id="element-121">
              <span className="text-steel-500 line-through text-xl" data-id="element-122">
                $12.99
              </span>
              <span className="text-4xl md:text-5xl font-bold text-amber-400" data-id="element-123">
                $6.39
              </span>
            </div>
          </div>

          <CTAButton data-id="element-124" />

          <div className="mt-8 flex items-center justify-center gap-4 text-sm text-steel-500" data-id="element-125">
            <span data-id="element-126">Pago 100% Seguro</span>
            <span data-id="element-127">•</span>
            <span data-id="element-128">Acceso de por vida</span>
          </div>
        </div>
      </div>
    </section>;
}